import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { TopBanner } from './components/TopBanner';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { QuickActions } from './components/QuickActions';
import { ProductGrid } from './components/ProductGrid';
import { AdviceSection } from './components/AdviceSection';
import { Footer } from './components/Footer';
import { CartProvider } from './context/CartContext';
import { ScrollToTop } from './components/ScrollToTop';
import { motion, AnimatePresence } from 'framer-motion';
// Pages
import { Prescriptions } from './pages/Prescriptions';
import { OTCProducts } from './pages/OTCProducts';
import { Services } from './pages/Services';
import { Locations } from './pages/Locations';
import { Cart } from './pages/Cart';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { HIPAA } from './pages/HIPAA';
import { Immunizations } from './pages/Immunizations';
import { HealthConsulting } from './pages/HealthConsulting';
import { TransferPrescription } from './pages/TransferPrescription';
function Home() {
  return <>
      <Hero data-id="element-0" data-mp="3mjgczu7zmpqf" />
      <QuickActions data-id="element-1" data-mp="3rc9e8848zfxr" />
      <ProductGrid data-id="element-2" data-mp="3rbrbqtqzs5he" />
      <AdviceSection data-id="element-3" data-mp="3rdatkosaqola" />
    </>;
}
export function App() {
  return <BrowserRouter data-id="element-4" data-mp="5opww5kum4f">
      <CartProvider data-id="element-5" data-mp="4wvhonpuufq">
        <ScrollToTop data-id="element-6" data-mp="5ggje8nxyxz" />
        <div className="min-h-screen flex flex-col font-sans selection:bg-clinical-blue selection:text-white bg-white" data-id="element-7" data-mp="82ovg3doih9">
          <header className="sticky top-0 z-50 w-full" data-id="element-8" data-mp="33mf2xuzktzfm">
            <TopBanner data-id="element-9" data-mp="33n6wl09m5n39" />
            <Navbar data-id="element-10" data-mp="33oi1j3esp0vy" />
          </header>
          <main className="flex-grow" data-id="element-11" data-mp="38li7lebna3n2">
            <AnimatePresence mode="wait" data-id="element-12" data-mp="38kgm0fx05yr3">
              <Routes data-id="element-13" data-mp="3dle1ulujigpf">
                <Route path="/" element={<Home data-id="element-15" data-mp="3dm5ylzzvikha" />} data-id="element-14" data-mp="3dlw542fmdv6u" />
                <Route path="/prescriptions" element={<Prescriptions data-id="element-17" data-mp="nwc1brepbtvq" />} data-id="element-16" data-mp="3dii716dzo857" />
                <Route path="/otc-products/:storeId" element={<OTCProducts data-id="element-19" data-mp="stc7017n2umb" />} data-id="element-18" data-mp="nvartrdc3fg4" />
                <Route path="/otc-products" element={<OTCProducts data-id="element-21" data-mp="35gnb7x88fm5" />} data-id="element-20" data-mp="36hzjfpzb85g" />
                <Route path="/services" element={<Services data-id="element-23" data-mp="3ud1ff9ao9oam" />} data-id="element-22" data-mp="38kxqn1ac7l9" />
                <Route path="/locations" element={<Locations data-id="element-25" data-mp="3uevs60bsia3m" />} data-id="element-24" data-mp="3ubriinfk2m5k" />
                <Route path="/cart" element={<Cart data-id="element-27" data-mp="d3mmvivk99nu" />} data-id="element-26" data-mp="d4e57s05daw6" />
                <Route path="/privacy" element={<Privacy data-id="element-29" data-mp="85l12q6r2w8o" />} data-id="element-28" data-mp="d3wbp34vdary" />
                <Route path="/terms" element={<Terms data-id="element-31" data-mp="864d5q9pyqes" />} data-id="element-30" data-mp="85b8qvy8gczt" />
                <Route path="/hipaa" element={<HIPAA data-id="element-33" data-mp="3gkuy3jvs9b9l" />} data-id="element-32" data-mp="83qdt580as1f" />
                <Route path="/immunizations" element={<Immunizations data-id="element-35" data-mp="3gj1qa19fol00" />} data-id="element-34" data-mp="3gm61hilbgh06" />
                <Route path="/health-consulting" element={<HealthConsulting data-id="element-37" data-mp="3qaxs9nen4v9i" />} data-id="element-36" data-mp="3bn2zk70muqwf" />
                <Route path="/transfer-prescription" element={<TransferPrescription data-id="element-39" data-mp="3ljphamxnx1u8" />} data-id="element-38" data-mp="3qcr2tdsdjzms" />
              </Routes>
            </AnimatePresence>
          </main>
          <Footer data-id="element-40" data-mp="2xt253pgprq1v" />
        </div>
      </CartProvider>
    </BrowserRouter>;
}